<app-navbar-style-one></app-navbar-style-one>

<div class="menu-page account-section">
    <div class="container-fluid">
        <div class="content-wrapper">
            <!-- Left Image -->
            <div class="left-image">
                <img src="../../../assets/img/home2/header1.jpg" alt="Chef seasoning steak">
            </div>

            <!-- Center Content -->
            <div class="center-content">
                <h2>{{ 'My favort' | titlecase}}</h2>
                <p>
                    Explore our menu and satisfy every craving — from cheesy pizzas to juicy burgers.
                </p>
            </div>

            <!-- Right Images -->
            <div class="right-images">
                <img src="../../../assets/img/home2/header3.jpg" alt="Stuffed mushroom dish">
                <img src="../../../assets/img/home2/header2.jpg" alt="Gourmet burger with fries">
            </div>
        </div>
    </div>
</div>

<section class="realMenuItems mt-4">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 mt-5 items">
                <div class="row w-100" *ngIf="!isLoading">
                    <!-- Dynamic Wishlist Items -->
                    <div class="col-lg-4 col-md-6 mt-3" *ngFor="let product of myWishListItems" >
                        <div class="menu-item-card p-2" style="border-radius: 8px;box-shadow: 0px 0px 10px 1px #0000004d;">
                            <h3 class="card-title">
                                <a href="product-details/{{product.id}}/{{product.name}}">{{product.name}} </a>
                                <label *ngIf="product.offer" class="offer-badge">{{ getOfferText(product.offer) }}</label>
                            </h3>
                            
                            <p class="card-description" *ngIf="product.components">{{product.components}}</p>
                            
                            <div class="card-image-container">
                                <a href="product-details/{{product.id}}/{{product.name}}">
                                    <img src="{{product.avatar}}" class="card-image" alt="{{product.name}}">
                                </a>
                            </div>
                                    
                            <div class="card-content ms-2 mt-2">
                                
                                <div class="card-footer">
                                    <div class="price"><span *ngIf="product.show_price == 1" >{{product.types[0].price | currency}}</span></div>
                                    <div class="card-actions">
                                        <a href="product-details/{{product.id}}/{{product.name}}" class="cart-btn"> <!--(click)="selectProduct(product.id)"-->
                                            <i class="bx bx-cart"></i>
                                        </a>
                                        <a (click)="toggleFav(product.id)" class="favorite-btn">
                                            <i class="bx bx-heart heart text-danger" [class.bxs-heart]="product.isFavorite" [class.text-danger]="product.isFavorite"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="myWishListItems.length === 0">
                        <div class="alert alert-danger p-4 text-center">
                            <strong>Oops!</strong> No Items Found in your Wishlist
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="isLoading">
                    <div class="col-12 text-center">
                        <div class="spinner-grow" role="status" >
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

                <!-- Pagination - Keeps your design but makes it functional -->
                <div class="row mt-4" *ngIf="data?.totalPages > 1">
                    <div class="col-12 text-center">
                        <button class="btn btn-outline-secondary me-2" 
                                (click)="prevPage()" 
                                [disabled]="pageNumber === 1">
                            Previous
                        </button>
                        <span class="mx-2">Page {{pageNumber}} of {{data?.totalPages}}</span>
                        <button class="btn btn-outline-secondary ms-2" 
                                (click)="nextPage()" 
                                [disabled]="pageNumber === data?.totalPages">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>